<footer>
  <section class="home-footer-top">
    <div class="container">
      <div class="footer-container">
        <div class="footer-box about-us">
          <h3 class="footer-box-title"><b>About Us</b></h3>
          <p>Built by habit nerds, for habit nerds. We're on a mission to make habit building fun and social – seamlessly integrated into Notion.
            Because lasting change happens when it feels like play.
            <br><br>
            <strong>Self-improvement, together.</strong></p>
        </div>
        <div class="footer-box contact">
          <h3 class="footer-box-title"><b>Contact</b></h3>
          <a href="mailto:contact@notionhabitheroes.com" class="footer-link">
            <strong>Email</strong><br>
            contact&#64;notionhabitheroes.com
          </a>
          <a href="https://www.linkedin.com/in/lucas-spiller/" target="_blank" rel="me noopener" class="footer-link footer-link-with-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            LinkedIn
          </a>
          <a href="https://www.youtube.com/@notionhabitheroes" target="_blank" rel="me noopener" class="footer-link footer-link-with-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
            YouTube
          </a>
        </div>
        <div class="footer-box disclaimer">
          <h3 class="footer-box-title"><b>Explore</b></h3>
          <div class="footer-groups">
            <div class="footer-group">
              <h4 class="footer-group-title">Product</h4>
              <a routerLink="/about" class="footer-link">About</a>
              <a routerLink="/blog" class="footer-link">Blog</a>
              <a routerLink="/template" class="footer-link">Template</a>
              <a routerLink="/blog/best-notion-habit-tracker-templates" class="footer-link">Best templates</a>
              <a routerLink="/notion-habit-tracker-widget" class="footer-link">Widget</a>
            </div>
            <div class="footer-group">
              <h4 class="footer-group-title">For</h4>
              <a routerLink="/teams" class="footer-link">For Teams</a>
              <a routerLink="/coaches" class="footer-link">For Coaches</a>
            </div>
            <div class="footer-group">
              <h4 class="footer-group-title">Help</h4>
              <a routerLink="/support" class="footer-link">Support &amp; FAQ</a>
              @if (loggedIn) {
                <a routerLink="/feedback" class="footer-link">Feedback</a>
              }
            </div>
            <div class="footer-group">
              <h4 class="footer-group-title">Legal</h4>
              <a routerLink="/imprint" class="footer-link">Imprint</a>
              <a routerLink="/terms" class="footer-link">Terms</a>
              <a routerLink="/privacy" class="footer-link">Privacy Policy</a>
            </div>
          </div>
          <p>© 2026 Habit Heroes</p>
        </div>
      </div>
      <p class="footer-legal">Habit Heroes is an independent project and is not affiliated with, endorsed by, or sponsored by Notion. Notion is a trademark of Notion Labs, Inc.</p>
    </div>
  </section>
</footer>
